import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import Pusher from 'pusher-js';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PusherService {
    private pusher: Pusher;

    constructor() {
        this.pusher = new Pusher(environment.pusherAppKey, {
            cluster: environment.cluster
        });
    }

    listen<T>(channelName: string, eventName: string): Observable<T> {
        return new Observable<T>(observer => {
            const channel = this.pusher.subscribe(channelName);

            const handler = (data: T) => {
                observer.next(data);
            };

            channel.bind(eventName, handler);

            // Teardown logic on unsubscribe
            return () => {
                channel.unbind(eventName, handler);
                this.pusher.unsubscribe(channelName);
            };
        });
    }
}
